module.exports = __webpack_public_path__ + "static/media/logo-blanco.3bb57169.svg";